import { DateTime } from 'luxon'

type ValidationResult = {
  isValid: boolean
  errorMessage: string
}

export const validateReportDates = (
  startDate: DateTime | null | undefined,
  endDate: DateTime | null | undefined,
): ValidationResult => {
  if (!startDate?.isValid || !endDate?.isValid) {
    return {
      isValid: false,
      errorMessage: '日付を選択してください',
    }
  }

  if (startDate > endDate) {
    return {
      isValid: false,
      errorMessage: '開始日が終了日より後になっています',
    }
  }

  const today = DateTime.local()
  const twoYearsAgo = today.minus({ years: 2 })
  if (startDate < twoYearsAgo) {
    return {
      isValid: false,
      errorMessage: '過去2年以内（今日含む）の日付を選択してください',
    }
  }

  const diffInDays = endDate.diff(startDate, 'days').days
  if (diffInDays > 90) {
    return {
      isValid: false,
      errorMessage: '90日未満の日付を選択してください',
    }
  }

  return {
    isValid: true,
    errorMessage: '',
  }
}
